import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import ButtonBase from "@mui/material/ButtonBase";
import {
    MODULE_SAISIE_TEMPS,
    MODULE_FLUIDES,
    MODULE_ABSENCES,
    MODULE_COMPONENTS_PARK,
    MODULE_INTERVENTIONS,
    MODULE_ANALYSE_RISQUES,
    MODULE_PPS,
    MODULE_SUIVI_CHANTIER,
    MODULE_HUMAN_RESOURCES,
} from "../redux/authorizedApps/authorizedAppsConstants";
import { authorizedAppsFetchData } from "../redux/authorizedApps/authorizedAppsActions";
import {
    redirectToLastVisualizedArOrPps,
    getLastVisualizedArOrPps,
    redirect,
    actualizeNumberOfArOrPpsToResend,
    setOnlyValidationInProgressChecked,
    redirectToListPage,
} from "../redux/analyseRisques/analyseRisquesActions";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import HelpIcon from "@mui/icons-material/Help";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import TimeEditIcon from "@mui/icons-material/History";
import TimelineIcon from "@mui/icons-material/Timeline";
import HistoryIcon from "@mui/icons-material/History";
import RefreshIcon from "@mui/icons-material/Refresh";
import BatteryIcon from "@mui/icons-material/Battery80";
import AddIcon from "@mui/icons-material/Add";
import PeopleIcon from "@mui/icons-material/People";
import { faHardHat, faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { setEditionState } from "../redux/absences/absencesActions";
import {
    getSearchHistoryType,
    getSearchHistoryLines,
} from "../redux/searchHistory/searchHistoryActions";
import {
    EQUIPMENT_CODE,
    LIQUID_BOTTLE_CODE,
} from "../redux/searchHistory/searchHistoryConstants";
import { liquidBottleFetchData } from "../redux/liquidBottles/liquidBottlesActions";
import { searchComponent } from "../redux/componentsPark/componentsParkActions";
import {
    getStartedWorkOrder,
    setCurrentIntervention,
} from "../redux/intervention/interventionActions";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { actualizeWaitingRequests } from "../redux/serviceWorker/swActions";
import Icon from "@mui/material/Icon/Icon";
import "./AppList.css";
import { styled } from '@mui/material/styles';
import { actualizeNumberNotesAssignedToMe } from "../redux/siteMonitoring/noteActions";

const styles = {
    root: {
        textAlign: "left",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
    },
    button: {
        marginLeft: "auto",
        marginRight: "auto",
        display: "block",
        width: "100%",
        textTransform: "uppercase",
        padding: "6px 8px",
        "&:hover": {
            backgroundColor: "unset",
        },
    },
    title: {
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        width: "50%",
        margin: "auto",
        borderStyle: "solid",
        borderWidth: "0px 0px 0px 1px",
        borderColor: "#005BBA",
        fontFamily: "EDF2020_Bold!important",
        display: "inline",
    },
    icon: {
        fontSize: "48px!important",
        display: "block",
        width: "48px",
        height: "48px",
        marginLeft: "auto",
        marginRight: "auto",
    },
    smallButton: {
        width: "100%",
        margin: 0,
        padding: 0,
        minWidth: "24px",
        maxWidth: "32px",
        minHeight: "24px",
        maxHeight: "32px",
    },
    faIcon: {
        color: "#FE5815",
        "&:hover": {
            color: "#001A70",
        },
    },
};

const CustomCard = styled(Card)(() => ({
    height: "140px",
    minHeight: "140px",
    maxHeight: "140px",
    margin: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    '& .MuiTypography-root': {
        fontSize: 12,
        fontWeight: "bold",
        fontFamily: "EDF2020_Bold!important",
        width: "100%",
    },
    '& .MuiCardContent-root': {
        padding: 1,
        width: "100%",
        textAlign: "center",
        maxHeight: "80px",
    },
  }));

  const CustomCardActions = styled(CardActions)(() => ({
    padding: 1,
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  }));

  const CustomTooltip = styled(Tooltip)(() => ({
    '& .MuiSvgIcon-root': {
        fontSize: 32,
        width: "32px",
        height: "32px",
    },
    '& .MuiIcon-root': {
        fontSize: 32,
        width: "32px",
        height: "32px",
    },
  }));

class MyOpenAppList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startedWorkOrder: null,
            lastVisualizedAr: null,
            lastVisualizedPps: null,
        }; //Nécessaire car getDerivedStateFromProps implémenté
        this.props.getSearchHistoryLines();
    }

    async componentDidMount() {
        this.props.actualizeWaitingRequests();
        this.props.actualizeNumberOfArOrPpsToResend(true);
        this.props.actualizeNumberOfArOrPpsToResend(false);
        this.props.actualizeNumberNotesAssignedToMe(this.props.activeUser.id);

        let lastVisualizedAr = await getLastVisualizedArOrPps();
        let lastVisualizedPps = await getLastVisualizedArOrPps(true);

        this.setState({
            lastVisualizedAr,
            lastVisualizedPps,
        });

        getStartedWorkOrder().then((wo) => {
            if (wo) {
                this.setState({
                    startedWorkOrder: wo,
                });
            }
        });
    }

    goToLastVizualizedEquipment(e) {
        let filteredSearchHistory = this.props.searchHistory.filter(
            (historyLine) =>
                historyLine.type === getSearchHistoryType(EQUIPMENT_CODE).id
        );
        if (filteredSearchHistory.length > 0) {
            this.props.searchComponent(
                filteredSearchHistory[0].searchInput,
                false,
                () => this.props.history.push("/componentsPark")
            );
        }

        e.stopPropagation();
    }

    goToLastVizualizedLiquidBottle(e) {
        let filteredSearchHistory = this.props.searchHistory.filter(
            (historyLine) =>
                historyLine.type === getSearchHistoryType(LIQUID_BOTTLE_CODE).id
        );
        if (filteredSearchHistory.length > 0) {
            this.props.history.push("/fluide");
            this.props.liquidBottleFetchData(
                filteredSearchHistory[0].searchInput
            );
        }

        e.stopPropagation();
    }

    goToStartedIntervention(e) {
        this.props.setCurrentIntervention(this.state.startedWorkOrder);
        this.props.history.push("/interventions/intervention");
        e.stopPropagation();
    }

    redirectTo(e, url) {
        if (url) window.open(url, "_blank");

        e.stopPropagation();
    }

    goTo(e, localeUrl) {
        this.props.history.push(localeUrl);
        e.stopPropagation();
    }

    continuePps(e) {
        this.props.redirectToLastVisualizedArOrPps(true);
        e.stopPropagation();
    }

    continueAr(e) {
        this.props.redirectToLastVisualizedArOrPps(false);
        e.stopPropagation();
    }

    arToReSend(e) {
        this.props.setOnlyValidationInProgressChecked(
            true,
            this.props.analysesRisques
        );
        this.props.redirectToListPage(false, this.props.analysesRisques);
        e.stopPropagation();
    }

    sppToReSend(e) {
        this.props.setOnlyValidationInProgressChecked(
            true,
            this.props.analysesRisques
        );
        this.props.redirectToListPage(true, this.props.analysesRisques);
        e.stopPropagation();
    }

    onModuleClick() {
        this.props.setOnlyValidationInProgressChecked(
            false,
            this.props.analysesRisques
        );
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.redirectUrl !== null) {
            nextProps.history.push(nextProps.redirectUrl);
            nextProps.resetRedirect();
        }

        return prevState;
    }

    onCreateAbsenceClick(e) {
        this.props.setEditionState(true, false, false);
        this.props.history.push("/absences/createAbsence");
        e.stopPropagation();
    }

    render() {
        const { classes } = this.props;

        if (this.props.isLoading) {
            return <p>Loading…</p>;
        }

        let resendArElement = <div />;
        let resendSppElement = <div />;
        let nbAllNotesElement = <div />;
        let nbEPIToCheckElement = <div />;
        let nbWaitingInterviewsElement = <div />;

        if (this.props.nbArToResend) {
            resendArElement = (
                <CustomTooltip
                    id="tooltip-icon"
                    title="Analyses de risques à renvoyer"
                >
                    <div
                        onClick={this.arToReSend.bind(this)}
                        className={classes.smallButton}
                    >
                        <RefreshIcon
                            color="primary"
                            className={classes.smallIcon}
                        />
                        <span className="badge badge-notify">
                            {this.props.nbArToResend}
                        </span>
                    </div>
                </CustomTooltip>
            );
        }

        if (this.props.nbSppToResend) {
            resendSppElement = (
                <CustomTooltip
                    id="tooltip-icon"
                    title="Plans de prévention simplifiés à renvoyer"
                >
                    <div
                        onClick={this.sppToReSend.bind(this)}
                        className={classes.smallButton}
                    >
                        <RefreshIcon
                            color="primary"
                            className={classes.smallIcon}
                        />
                        <span className="badge badge-notify">
                            {this.props.nbSppToResend}
                        </span>
                    </div>
                </CustomTooltip>
            );
        }

        if (this.props.nbAllNotes) {
            nbAllNotesElement = (
                <CustomTooltip
                    id="tooltip-icon"
                    title="Notifications"
                >
                    <div
                        //onClick={this.sppToReSend.bind(this)}
                        className={classes.smallButton}
                    >
                        <NotificationsActiveIcon
                            fontSize="small"
                            className="red-icon"
                        />
                        <span className="badge badge-notify" style={{top: '-40px', left: '10px'}}>
                            {this.props.nbAllNotes}
                        </span>
                    </div>
                </CustomTooltip>
            );
        }

        if (this.props.nbEPIToCheck) {
            nbEPIToCheckElement = (
                <CustomTooltip
                    id="tooltip-icon"
                    title="Notifications"
                >
                    <div
                        className={classes.smallButton}
                    >
                        <NotificationsActiveIcon
                            fontSize="small"
                            className="red-icon"
                        />
                        <span className="badge badge-notify" style={{top: '-40px', left: '10px'}}>
                            {this.props.nbEPIToCheck}
                        </span>
                    </div>
                </CustomTooltip>
            );
        }

        if (this.props.nbWaitingInterviews) {
            nbWaitingInterviewsElement = (
                <CustomTooltip
                    id="tooltip-icon"
                    title="Notifications"
                >
                    <div
                        className={classes.smallButton}
                    >
                        <NotificationsActiveIcon
                            fontSize="small"
                            className="red-icon"
                        />
                        <span className="badge badge-notify" style={{top: '-40px', left: '10px'}}>
                            {this.props.nbWaitingInterviews}
                        </span>
                    </div>
                </CustomTooltip>
            );
        }

        return (
            <div className={classes.root}>
                <div className="row">
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_SAISIE_TEMPS
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="activity-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) => this.goTo(e, "/activity")}
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <TimeEditIcon
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Saisie des temps
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_SAISIE_TEMPS
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        <CustomTooltip
                                            id="tooltip-icon"
                                            title="Rapport d'activité"
                                        >
                                            <div
                                                onClick={(e) =>
                                                    this.goTo(
                                                        e,
                                                        "/activity/report"
                                                    )
                                                }
                                                className={classes.smallButton}
                                            >
                                                <TimelineIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_INTERVENTIONS
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="interventions-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) =>
                                        this.goTo(e, "/interventions")
                                    }
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={faClipboardList}
                                                className={
                                                    classes.faIcon + " fa-3x"
                                                }
                                                alt="Interventions"
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Interventions
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_INTERVENTIONS
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {this.state.startedWorkOrder ? (
                                            <CustomTooltip
                                                id="tooltip-icon"
                                                title="Intervention en cours"
                                            >
                                                <div
                                                    onClick={this.goToStartedIntervention.bind(
                                                        this
                                                    )}
                                                    className={
                                                        classes.smallButton
                                                    }
                                                >
                                                    <Icon
                                                        color="primary"
                                                    >
                                                        playlist_play
                                                    </Icon>
                                                </div>
                                            </CustomTooltip>
                                        ) : null}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) => authorizedApp.code === MODULE_FLUIDES
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="liquid-bottles-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) => this.goTo(e, "/fluide")}
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <BatteryIcon
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Fluides
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_FLUIDES
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {this.props.searchHistory.filter(
                                            (historyLine) =>
                                                historyLine.type ===
                                                getSearchHistoryType(
                                                    LIQUID_BOTTLE_CODE
                                                ).id
                                        ).length > 0 ? (
                                            <CustomTooltip
                                                id="tooltip-icon"
                                                title="Dernière bouteille"
                                            >
                                                <div
                                                    onClick={this.goToLastVizualizedLiquidBottle.bind(
                                                        this
                                                    )}
                                                    className={
                                                        classes.smallButton
                                                    }
                                                >
                                                    <HistoryIcon
                                                        color="primary"
                                                    />
                                                </div>
                                            </CustomTooltip>
                                        ) : null}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_COMPONENTS_PARK
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="components-park-card"
                                    className={`app-list-card component-park-icon-div full_size`}
                                    onClick={(e) =>
                                        this.goTo(e, "/componentsPark")
                                    }
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <div
                                                color="secondary"
                                                className="component-park-icon span-center"
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Parc machines
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_COMPONENTS_PARK
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {this.props.searchHistory.filter(
                                            (historyLine) =>
                                                historyLine.type ===
                                                getSearchHistoryType(
                                                    EQUIPMENT_CODE
                                                ).id
                                        ).length > 0 ? (
                                            <CustomTooltip
                                                id="tooltip-icon"
                                                title="Dernier équipement"
                                            >
                                                <div
                                                    onClick={this.goToLastVizualizedEquipment.bind(
                                                        this
                                                    )}
                                                    className={
                                                        classes.smallButton
                                                    }
                                                >
                                                    <HistoryIcon
                                                        color="primary"
                                                        className={
                                                            classes.smallIcon
                                                        }
                                                    />
                                                </div>
                                            </CustomTooltip>
                                        ) : null}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_ANALYSE_RISQUES
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="ar-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) =>
                                        this.goTo(e, "/analyseRisques")
                                    }
                                >
                                    <CardContent>
                                        <div
                                            className={classes.button}
                                            onClick={this.onModuleClick.bind(
                                                this
                                            )}
                                        >
                                            <ErrorOutlineIcon
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Analyse de risques
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_ANALYSE_RISQUES
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {resendArElement}
                                        {this.state.lastVisualizedAr ? (
                                            <CustomTooltip
                                                id="tooltip-icon"
                                                title="Reprendre la dernière AR"
                                            >
                                                <div
                                                    onClick={this.continueAr.bind(
                                                        this
                                                    )}
                                                    className={
                                                        classes.smallButton
                                                    }
                                                >
                                                    <HistoryIcon
                                                        color="primary"
                                                        className={
                                                            classes.smallIcon
                                                        }
                                                    />
                                                </div>
                                            </CustomTooltip>
                                        ) : null}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) => authorizedApp.code === MODULE_PPS
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="pps-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) => this.goTo(e, "/pps")}
                                >
                                    <CardContent>
                                        <div
                                            className={classes.button}
                                            onClick={this.onModuleClick.bind(
                                                this
                                            )}
                                        >
                                            <VerifiedUserIcon
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Plan de prévention
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_PPS
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {resendSppElement}
                                        {this.state.lastVisualizedPps ? (
                                            <CustomTooltip
                                                id="tooltip-icon"
                                                title="Reprendre le dernier PPS"
                                            >
                                                <div
                                                    onClick={this.continuePps.bind(
                                                        this
                                                    )}
                                                    className={
                                                        classes.smallButton
                                                    }
                                                >
                                                    <HistoryIcon
                                                        color="primary"
                                                        className={
                                                            classes.smallIcon
                                                        }
                                                    />
                                                </div>
                                            </CustomTooltip>
                                        ) : null}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_ABSENCES
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    className={`app-list-card full_size`}
                                    id="absences-card"
                                    onClick={(e) => this.goTo(e, "/absences")}
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <EventBusyIcon
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Absences
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_ABSENCES
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        <CustomTooltip
                                            id="tooltip-icon"
                                            title="Créer absence"
                                        >
                                            <div
                                                onClick={this.onCreateAbsenceClick.bind(
                                                    this
                                                )}
                                                className={classes.smallButton}
                                            >
                                                <AddIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_SUIVI_CHANTIER
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="site-monitoring-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) =>
                                        this.goTo(e, "/siteMonitorings")
                                    }
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={faHardHat}
                                                className={
                                                    classes.faIcon + " fa-3x"
                                                }
                                                alt="siteMonitorings"
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Suivi de chantier
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_SUIVI_CHANTIER
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {nbAllNotesElement}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {this.props.authorizedApps.filter(
                        (authorizedApp) =>
                            authorizedApp.code === MODULE_HUMAN_RESOURCES
                    ).length > 0 && (
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="human-resources-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) =>
                                        this.goTo(e, "/humanResources")
                                    }
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <PeopleIcon
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Ressources humaines
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        this.props.authorizedApps.filter(
                                                            (authorizedApp) =>
                                                                authorizedApp.code ===
                                                                MODULE_HUMAN_RESOURCES
                                                        )[0].HelpUrl
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {nbWaitingInterviewsElement}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    )}
                    {<div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
                            <ButtonBase className="full_size">
                                <CustomCard
                                    id="epi-card"
                                    className={`app-list-card full_size`}
                                    onClick={(e) =>
                                        this.goTo(e, "/epis")
                                    }
                                >
                                    <CardContent>
                                        <div
                                            className={
                                                classes.button +
                                                " without-side-padding"
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={faScrewdriverWrench}
                                                className={
                                                    classes.faIcon + " fa-3x"
                                                }
                                                alt="Équipement/EPI"
                                            />
                                            <Typography
                                                color="primary"
                                            >
                                                Équipement/EPI
                                            </Typography>
                                        </div>
                                    </CardContent>
                                    <CustomCardActions
                                        disableSpacing
                                    >
                                        <CustomTooltip id="tooltip-icon" title="Aide">
                                            <div
                                                className={classes.smallButton}
                                                onClick={(e) =>
                                                    this.redirectTo(
                                                        e,
                                                        ""
                                                    )
                                                }
                                            >
                                                <HelpIcon
                                                    color="primary"
                                                />
                                            </div>
                                        </CustomTooltip>
                                        {nbEPIToCheckElement}
                                    </CustomCardActions>
                                </CustomCard>
                            </ButtonBase>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

MyOpenAppList.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        analysesRisques: state.analysesRisques,
        activeUser: state.activeUser,
        authorizedApps: state.authorizedApps,
        hasErrored: state.authorizedAppsHasErrored,
        isLoading: state.authorizedAppsIsLoading,
        searchHistory: state.searchHistory.searchHistory,
        redirectUrl: state.analyseRisques.redirectUrl,
        nbArToResend: state.analysesRisques.nbArToResend,
        nbSppToResend: state.analysesRisques.nbSppToResend,
        nbAllNotes: state.notes.nbAllNotes,
        nbEPIToCheck: state.equipmentsEPI.nbEPIToCheck,
        nbWaitingInterviews: state.forms.nbWaitingInterviews
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getSearchHistoryLines: () => dispatch(getSearchHistoryLines()),
        searchComponent: (code) => dispatch(searchComponent(code)),
        liquidBottleFetchData: (code) => dispatch(liquidBottleFetchData(code)),
        fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
        setEditionState: (creationMode, updateMode, validationMode) =>
            dispatch(setEditionState(creationMode, updateMode, validationMode)),
        redirectToLastVisualizedArOrPps: (pps) =>
            dispatch(redirectToLastVisualizedArOrPps(pps)),
        redirectToListPage: (moduleSpp, analysesRisquesState) =>
            dispatch(redirectToListPage(moduleSpp, analysesRisquesState)),
        setOnlyValidationInProgressChecked: (value, analysesRisquesState) =>
            dispatch(
                setOnlyValidationInProgressChecked(value, analysesRisquesState)
            ),
        resetRedirect: () => dispatch(redirect(null)),
        actualizeNumberOfArOrPpsToResend: (moduleSpp) =>
            dispatch(actualizeNumberOfArOrPpsToResend(moduleSpp)),
        actualizeWaitingRequests: () => dispatch(actualizeWaitingRequests()),
        setCurrentIntervention: (intervention) =>
            dispatch(setCurrentIntervention(intervention)),
        actualizeNumberNotesAssignedToMe: (userId) => dispatch(actualizeNumberNotesAssignedToMe(userId))        
    };
};
export default compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(MyOpenAppList);
